<button
  [id]="triggerId"
  class="dropdown-trigger"
  [class.dropdown-trigger--error]="hasError"
  [class.dropdown-trigger--disabled]="disabled"
  [class.dropdown-trigger--open]="isOpen"
  [attr.tabindex]="tabindex"
  type="button"
  [attr.aria-labelledby]="triggerId"
  aria-haspopup="listbox"
  [attr.aria-expanded]="ariaExpanded"
  [disabled]="disabled"
  (click)="stopPropagation($event)"
  data-test="dropdown-trigger"
>
  {{ label }}
  <vtmn-play-icon [name]="iconName"></vtmn-play-icon>
</button>
